'use client';

import { Help } from '@mui/icons-material';

import { styled } from '../../../styles';

export const TooltipHeadCellContainer = styled.div(
  () =>
    ({
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    } as const),
);

export const TooltipHeadCellIcon = styled(Help)(({ theme }) => ({
  color: theme.palette.text4,
  width: theme.spacing(4),
  height: theme.spacing(4),
  marginLeft: theme.spacing(2),
}));
